define('modules/form_editor/models/check_group',['require','exports','module','backbone','./check_radio_option','./base_form_element'],function (require, exports, module) {
  'use strict';
  var Backbone = require('backbone'),
    CheckGroupOption = require('./check_radio_option'),
    BaseFormElement = require('./base_form_element');

  var Controller = {
    getNewItemIndex: function () {
      var newItemIndex = 1;

      // Search function must outside for the linter happiness
      const hasTextConflict = function (item) {
        return item.get('text') === 'Item' + newItemIndex;
      };

      // find next available index
      while (this.items.find(hasTextConflict)) {
        newItemIndex++;
      }

      return newItemIndex;
    },

    addItem: function (atIndex) {
      const itemsCount = this.items.length;
      const newItemIndex = this.getNewItemIndex();
      const destIndex = atIndex || itemsCount;
      const newItem = new CheckGroupOption({
        text: 'Item' + newItemIndex,
      });

      this.items.add(newItem, { at: destIndex });
      this.trigger('change');
    },

    removeItem: function (item) {
      //keep at least one
      if (this.items.length > 1) {
        this.items.remove(item);
        this.trigger('change');
      }
    },

    addItemAfter: function (refModel) {
      var index = this.items.indexOf(refModel);

      if (index === -1) {
        index = this.items.length - 1;
      }

      this.addItem(index + 1);
      this.items.trigger('sort');
    },

    clone: function () {
      var copy = module.exports.__super__.clone.apply(this);
      //remove first one
      copy.items.reset([]);
      //copy this model's items to the new one
      this.items.each(function (item) {
        copy.items.add(item.clone());
      }, this);
      return copy;
    },
  };

  module.exports = BaseFormElement.extend({
    name: 'input:check',
    initialize: function (attrs, options) {
      this.items = new Backbone.Collection(attrs.items, { model: CheckGroupOption });
      if (this.items.length === 0) {
        this.addItem();
      }
      //backwards compat for nameAttr: if not present, get labelText
      this.backwardsCompat(attrs);
    },
  });

  _.extend(module.exports.prototype, Controller);
});

